<template>
    <div v-if="question" class="q-wrap">
        <div class="q-input">
            <kimsa-text-field @change="answer = $event" :value="answer" :placeholder="$t('common.write_here')"
                dense no-elevation inputMode="decimal" customKeypress @keypress="onKeypress" />
        </div>
        <div class="q-actions">
            <v-btn block large depressed color="primary" class="black--text q-next" :disabled="!answer"
                @click="sendAnswer">
                {{ $t('common.next') }}
            </v-btn>
        </div>
    </div>
</template>

<script>
import KimsaTextField from '../../common/inputs/KimsaTextField.vue'
export default {
    components: { KimsaTextField },
    props: {
        question: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            answer: ''
        }
    },
    methods: {
        onKeypress(event) {
            const charCode = event.keyCode
            if ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 44) return
            event.preventDefault()
        },
        sendAnswer() {
            const vm = this
            const normalized = String(vm.answer || '').replace(',', '.').trim()
            const num = parseFloat(normalized)
            vm.$emit('click:next', vm.question, { value: Number.isFinite(num) ? num : normalized })
        }
    },
}
</script>

<style scoped>
.q-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 16px;
    padding-top: 20px;
}

.q-input {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
}

.q-actions {
    max-width: 480px;
    width: 100%;
    margin: 0 auto;
    padding-bottom: 8px;
}

.q-next {
    border-radius: 12px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0;
}
</style>
